<template>
  <div class="action-button moderate" @click="$emit('click')">
    <i class="action-icon fal fa-exclamation-triangle"></i>
    <p class="action-text">Denunciar un abuso
      <span v-if="total" class="moderated-votes">({{ total }})</span>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'edi-moderate-comment-btn',
    props: {
      total: Number
    }
  }
</script>
